export default "/Score.png";